import type { ValidationConfig } from '../../../core/dataProcessor/types';

export const scatter3DValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: ['string', 'date'], required: true },
    { field: 'z', type: 'number', required: true },
    { field: 'size', type: 'number', required: false },
    { field: 'color', type: 'number', required: false }
  ],
  businessRules: [
    {
      name: 'scatter3d-sufficient-data',
      validator: data => Array.isArray(data) && data.length > 1,
      message: '3D scatter plot requires more than 1 data point to be effective',
      suggestion: 'Provide at least 2 data points for meaningful 3D visualization',
      severity: 'warning'
    }
  ]
};
